/*
 * Copyright © 2021 Firecrest Clinical, Ltd.
 * All rights reserved.
 */

import { ElementRef, Injectable } from '@angular/core';
import { Observable, Observer } from 'rxjs';
import * as _ from 'lodash';
import { FcResponsiveAgDialogOptions } from './fc-responsive-ag-dialog-options';

/**.
 * Dialog component with Angular
 *
 * @template T - modal data;
 */
@Injectable()
export class FcResponsiveAgDialogComponent {
    private observer: Observer<any>;
    
    /**
     * Component wrapper element.
     */
    wrapper: ElementRef;

    /**
     * Ref of options for this component.
     */
    options: FcResponsiveAgDialogOptions;
    
    private closerCallback: (component:any) => void = () => {};
    
    /**
     * Default constructor.
     */
    constructor() {}
    
    /**
     * Map data to dialog data.
     * 
     * @param data User data.
     */
    mapDataObject(data: any): void {
        _.merge(this, data);
    }
    
    /**
     * Create a observable object.
     * 
     * @returns Observable Observable object.
     */
    setupObserver(): Observable<any> {
        return new Observable((observer: Observer<any>) => {
            this.observer = observer;
        });
    }

    /**
     * Defines what happens when close is called - default this
     * will just call the default remove modal process. If overridden
     * must include.
     *
     * @param callback On closing callback.
     */
    onClosing(callback: (component: FcResponsiveAgDialogComponent) => void): void {
        this.closerCallback = callback;
    }

    /**
     * Close dialog function.
     * 
     * @param value Custom value.
     */
    close(value?: any): void {
        this.closerCallback(this);
        if (this.observer) {
            this.observer.next(value);
            this.observer.complete();
        }
    }
}